import React from 'react'

const RenderAccountList = ({account,accountCountryList,getProductRelatedTaxonomy}) => {
  if(account !== '' && account !== null && account !== undefined){
    return (
      <div style={{display: 'inline-block'}}>
       <span>{account.accountType !== undefined ? accountCountryList? getProductRelatedTaxonomy(account).accountType.name:account.accountType.name + ',' : ''}</span>
       <span>{account.accountNumber !== undefined && account.accountNumber !== '' ? account.accountNumber + ',' : ''}</span>
       <span>{account.branchCode !== undefined && account.branchCode !== '' ? account.branchCode : ''}</span>
       <span>{account.country !== undefined ? accountCountryList? getProductRelatedTaxonomy(account).country.name:account.country.name + ',' : ''}</span>
       <span>{account.currency !== undefined ? account.currency.name : ''}</span>
       <br/>
       <span>{account.accountHolder !== undefined ? account.accountHolder.name : ''}</span>
       <br/>
       <span>{account.hsbcBankName !== undefined ? account.hsbcBankName.name + ',' : ''}</span>
       <span>{account.bankName !== undefined ? account.bankName + ',': ''}</span>
       <span>{account.accountTitle !== undefined ? account.accountTitle : ''}</span>
       <span>{account.tempRefrenceId !== undefined && account.tempRefrenceId !== '' ? `(${account.tempRefrenceId})` : ''}</span>
      </div>
    )
  }else {
    return ''
  }
}

// Detail Setting Section
const DetailedSetting = ({data,pageJson,translations,translateWordForOption, accountCountryList, getProductRelatedTaxonomy}) => {
  if(pageJson !== undefined){
    return (
      <div className="ie-detail-section">
        <div className="ie-detail-section__heading">{`5. ${translations(pageJson.pageHeading)}`}</div>
        {
            data.interestEnhancement !== undefined && data.interestEnhancement.detailedSettings.map((item,key) => (
            <div className="ie-detail-section__content" key={key}>
              <dl className="ie-detail-section__content__list">
                <dt>{translations(pageJson.country)}</dt>
                <dd>{item.country}</dd>
                <dt>{translations(pageJson.account)}</dt>
                <dd>
                  {
                    <RenderAccountList account={item.account}
                    accountCountryList ={accountCountryList}
                    getProductRelatedTaxonomy = {getProductRelatedTaxonomy}/>
                  }
                </dd>
              </dl>
              <hr/>
              <dl className="ie-detail-section__content__list">
                <dt>{translations(pageJson.interestContribution)}</dt>
                <dd>{item.interestContribution !== undefined ? item.interestContribution.value : ''}</dd>
              </dl>
              {
                item.interestContribution !== undefined && item.interestContribution.value.toLowerCase() === 'Interest Contribution'.toLowerCase()
                ? <div>

                    <div className="ie-detail-section__content__heading">{translations(pageJson.credit)}</div>
                    <dl className="ie-detail-section__content__list">
                      <dt>{translations(pageJson.baseRate)}</dt>
                      {
                        item.baseRateCredit !== undefined && 'baseRateCredit' in item && 'baseRate' in item.baseRateCredit
                        ? <dd>{item.baseRateCredit.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.code)}</dt>
                      {
                          item.baseRateCredit !== undefined && 'baseRateCredit' in item && 'baseRateCode' in item.baseRateCredit
                        ? <dd>{item.baseRateCredit.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.spread)}</dt>
                      {
                        item.baseRateCredit !== undefined && 'baseRateCredit' in item && 'spread' in item.baseRateCredit
                        ? <dd>{item.baseRateCredit.spread}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>&nbsp;</dt>
                      <dd>
                        {
                          item.baseRateCredit !== undefined
                          ? `${item.baseRateCredit.marginBaseRate === true
                            ? translations(pageJson.margin)
                            : translations(pageJson.fixedValue)}`
                          : ''
                        }
                      </dd>
                      <dt>{translations(pageJson.maxInterest)}</dt>
                      {
                        item.baseRateCredit !== undefined && 'baseRateCredit' in item && 'maximumInterest' in item.baseRateCredit
                        ? <dd>{item.baseRateCredit.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.minInterest)}</dt>
                      {
                        item.baseRateCredit !== undefined && 'baseRateCredit' in item && 'minimumInterest' in item.baseRateCredit
                        ? <dd>{item.baseRateCredit.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                      }
                    </dl>

                    <div className="ie-detail-section__content__heading">{translations(pageJson.debit)}</div>
                    <dl className="ie-detail-section__content__list">
                      <dt>{translations(pageJson.baseRate)}</dt>
                      {
                        item.baseRateDebit !== undefined && 'baseRateDebit' in item && 'baseRate' in item.baseRateDebit
                        ? <dd>{item.baseRateDebit.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.code)}</dt>
                      {
                        item.baseRateDebit !== undefined && 'baseRateDebit' in item && 'baseRateCode' in item.baseRateDebit
                        ? <dd>{item.baseRateDebit.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.spread)}</dt>
                      {
                        item.baseRateDebit !== undefined && 'baseRateDebit' in item && 'spread' in item.baseRateDebit
                        ? <dd>{item.baseRateDebit.spread}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>&nbsp;</dt>
                      <dd>
                        {
                          item.baseRateDebit !== undefined
                          ? `${item.baseRateDebit.marginBaseRate === true
                              ? translations(pageJson.margin)
                              : translations(pageJson.fixedValue)}`
                          : ''
                        }
                      </dd>
                      <dt>{translations(pageJson.maxInterest)}</dt>
                      {
                        item.baseRateDebit !== undefined && 'baseRateDebit' in item && 'maximumInterest' in item.baseRateDebit
                        ? <dd>{item.baseRateDebit.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.minInterest)}</dt>
                      {
                        item.baseRateDebit !== undefined && 'baseRateDebit' in item && 'minimumInterest' in item.baseRateDebit
                        ? <dd>{item.baseRateDebit.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                      }
                    </dl>
                    <hr />
                    <dl className="ie-detail-section__content__list">
                      <dt>{translations(pageJson.setOdLimit)}</dt>
                      <dd>{item.odLimit}</dd>
                      <dt>{translations(pageJson.unauthorisedInterestedType)}</dt>
                      <dd>{item.unauthorizedInterestType !== undefined ? item.unauthorizedInterestType === 'fixedValue' ? translations(pageJson.fixed) : translations(pageJson.floating) : '' }</dd>
                    </dl>
                    <div className="ie-detail-section__content__heading">{translations(pageJson.unouthorisedOD)}</div>
                    <dl className="ie-detail-section__content__list">
                      <dt>{translations(pageJson.baseRate)}</dt>
                      {
                        item.unauthorizedOD !== undefined && 'unauthorizedOD' in item && 'baseRate' in item.unauthorizedOD
                        ? <dd>{item.unauthorizedOD.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.code)}</dt>
                      {
                        item.unauthorizedOD !== undefined && 'unauthorizedOD' in item && 'baseRateCode' in item.unauthorizedOD
                        ? <dd>{item.unauthorizedOD.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.spread)}</dt>
                      {
                        item.unauthorizedOD !== undefined && 'unauthorizedOD' in item && 'spread' in item.unauthorizedOD
                        ? <dd>{item.unauthorizedOD.spread}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>&nbsp;</dt>
                      <dd>
                        {
                          item.unauthorizedOD !== undefined
                          ? `${item.unauthorizedOD.marginBaseRate === true
                            ? translations(pageJson.margin)
                            : translations(pageJson.fixedValue)}`
                          : ''
                        }
                      </dd>
                      <dt>{translations(pageJson.maxInterest)}</dt>
                      {
                        item.unauthorizedOD !== undefined && 'unauthorizedOD' in item && 'maximumInterest' in item.unauthorizedOD
                        ? <dd>{item.unauthorizedOD.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                      }
                      <dt>{translations(pageJson.minInterest)}</dt>
                      {
                        item.unauthorizedOD !== undefined && 'unauthorizedOD' in item && 'minimumInterest' in item.unauthorizedOD
                        ? <dd>{item.unauthorizedOD.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                      }
                    </dl>
                    {
                      item.tiers.length > 0 ? item.tiers.map((item,subKey) => {
                        return (
                          <div key={subKey} className="ie-detailed-section">
                            <div className="ie-detailed-section__tier-heading">{`${translations(pageJson.tier)} ${subKey+1}`}</div>
                            <div className="ie-detailed-section__tier-content">
                              <dl className="ie-detailed-section__tier">
                                <dt>{translations(pageJson.enhanceMarginText)}</dt>
                                <dd>{item.balanceForEnhancementMargin}</dd>
                                {
                                  data.marginApplicable ===  true && data.interestEnhancement.detailedSettings[key].premiumMargin === true
                                  ? <div>
                                      <dt>{translations(pageJson.premiumMarginText)}</dt>
                                      <dd>{item.balanceEligibleAccountsForPremiumMargin}</dd>
                                    </div>
                                  : ''
                                }
                              </dl>
                            </div>
                          </div>
                        )
                      }) :''
                    }
                  </div>
                : null
              }

            </div>
          ))
        }
      </div>
    )
  }else {
    return null
  }
}


export default DetailedSetting;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/IEPreview/DetailedSetting.js